export const CREATE_STORE_REQUEST = "CREATE_STORE_REQUEST";
export const CREATE_STORE_SUCCESS = "CREATE_STORE_SUCCESS";
export const CREATE_STORE_FAIL = "CREATE_STORE_FAIL";
export const CREATE_STORE_RESET = "CREATE_STORE_RESET";

export const ALL_STORE_REQUEST = "ALL_STORE_REQUEST";
export const ALL_STORE_SUCCESS = "ALL_STORE_SUCCESS";
export const ALL_STORE_FAIL = "ALL_STORE_FAIL";

export const STORE_COMPLAINTS_REQUEST = "STORE_COMPLAINTS_REQUEST";
export const STORE_COMPLAINTS_SUCCESS = "STORE_COMPLAINTS_SUCCESS";
export const STORE_COMPLAINTS_FAIL = "STORE_COMPLAINTS_FAIL";

export const STORE_LOGIN_REQUEST = "STORE_LOGIN_REQUEST";
export const STORE_LOGIN_SUCCESS = "STORE_LOGIN_SUCCESS";
export const STORE_LOGIN_FAIL = "STORE_LOGIN_FAIL";


export const UPDATE_COMPLAINT_STATUS_REQUEST =
  "UPDATE_COMPLAINT_STATUS_REQUEST";
export const UPDATE_COMPLAINT_STATUS_SUCCESS =
  "UPDATE_COMPLAINT_STATUS_SUCCESS";
export const UPDATE_COMPLAINT_STATUS_FAIL =
  "UPDATE_COMPLAINT_STATUS_FAIL";
